import { render, staticRenderFns } from "./doge.vue?vue&type=template&id=17006bf4&scoped=true"
import script from "./doge.vue?vue&type=script&lang=js"
export * from "./doge.vue?vue&type=script&lang=js"
import style0 from "./doge.vue?vue&type=style&index=0&id=17006bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17006bf4",
  null
  
)

export default component.exports